<template>
    <div>
        <NavabrSaas />
        <GetInTouch />
        <FooterTafiCloud />
    </div>
</template>

<script>
import NavabrSaas from '@/components/Navbar/Navabr-saas.vue';
import GetInTouch from '@/components/GetInTouch.vue';
import FooterTafiCloud from '@/components/Footer/Footer-TafiCloud.vue';

export default {
    name: "ContactPage",
    components: {
        NavabrSaas,
        GetInTouch,
        FooterTafiCloud,
    },
   
}
</script>

<style lang="scss" scoped></style>